import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import TabNavigatorHeader from "./TabNavigatorHeader";
import { StackParamList, TabParamList, productFormRoutes } from "./types";
import SubmitButton from "../components/SubmitButton";
import CombinationInventoryScreen, {
  combinationInventoryScreenOptions,
} from "../screens/CombinationInventoryScreen";
import DescriptionScreen from "../screens/DescriptionScreen";
import InventoryScreen from "../screens/InventoryScreen";
import PriceFormScreen, {
  priceFormScreenOptions,
} from "../screens/PriceFormScreen";
import PricesScreen from "../screens/PricesScreen";
import VariantCombinationsScreen, {
  variantCombinationsScreenOptions,
} from "../screens/VariantCombinationsScreen";
import VariantFormScreen, {
  variantFormScreenOptions,
} from "../screens/VariantFormScreen";
import VariantsScreen from "../screens/VariantsScreen";

const Tab = createMaterialTopTabNavigator<TabParamList>();
const Stack = createNativeStackNavigator<StackParamList>();

export default function StackNavigator() {
  const {
    tabs,
    priceForm,
    variantForm,
    variantCombinations,
    combinationInventory,
  } = productFormRoutes;

  return (
    <Stack.Navigator initialRouteName={tabs.navigator}>
      <Stack.Screen
        name={tabs.navigator}
        component={TabNavigator}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={variantForm}
        component={VariantFormScreen}
        options={variantFormScreenOptions}
      />
      <Stack.Screen
        name={variantCombinations}
        component={VariantCombinationsScreen}
        options={variantCombinationsScreenOptions}
      />
      <Stack.Screen
        name={combinationInventory}
        component={CombinationInventoryScreen}
        options={combinationInventoryScreenOptions}
      />
      <Stack.Screen
        name={priceForm}
        component={PriceFormScreen}
        options={priceFormScreenOptions}
      />
    </Stack.Navigator>
  );
}

function TabNavigator() {
  const { description, prices, inventory, variants } =
    productFormRoutes.tabs;
  return (
    <>
      <Tab.Navigator tabBar={TabNavigatorHeader} initialRouteName={description}>
        <Tab.Screen name={description} component={DescriptionScreen} />
        <Tab.Screen name={prices} component={PricesScreen} />

        <Tab.Screen name={inventory} component={InventoryScreen} />
        <Tab.Screen name={variants} component={VariantsScreen} />
      </Tab.Navigator>
      <SubmitButton />
    </>
  );
}
